import React, { useState } from "react";
import cx from "classnames";
import { ReactComponent as Visible } from "./icons/visible.svg";
import { ReactComponent as Invisible } from "./icons/invisible.svg";

type Props = {
  placeholder: string;
  value: string;
  label?: string;
  labelStyle?: any;
  type?: string;
  isHelp?: boolean;
  helpText?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const PasswordInputAuth: React.FC<Props> = ({
  placeholder,
  label,
  helpText,
  isHelp,
  className,
  value,
  onChange,
  onBlur,
  maxLength,
  disabled,
}): JSX.Element => {
  const [isVisible, setVisible] = useState(false);

  const handleClick = () => {
    setVisible(!isVisible);
  };
  return (
    <div className={cx("flex flex-col min-w-0", className)}>
      {label && (
        <span
          className="font-sora text-xs mb-2"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#4F4F4F",
          }}
        >
          {label}
        </span>
      )}
      <div
        className="flex flex-row font-sora border-bt-gray"
        style={{
          border: isHelp ? "2px solid #FD5B28" : "0.5px solid #8E8E8E",
          borderRadius: "4px",
          background: "#FFFFFF",
        }}
      >
        <input
          className={cx(
            "w-full border-none mr-3 my-1 px-2 py-2 border-transparent focus:border-transparent focus:ring-0 text-sm font-sora",
            isHelp ? "border-bt-red" : ""
          )}
          type={isVisible ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          autoComplete="off"
          disabled={disabled}
        />
        <div className="">
          <span className="flex mr-2 mt-3.5" onClick={handleClick}>
            {isVisible ? <Visible /> : <Invisible />}
          </span>
        </div>
      </div>
      {isHelp && helpText && (
        <div className="flex flex-row">
          <span className="font-nunito mt-1 text-xs text-bt-red">
            {helpText}
          </span>
        </div>
      )}
    </div>
  );
};

export default PasswordInputAuth;
